import { useEffect, useRef } from 'react';

export function useResetFilters<T>(
  configuration: T | undefined,
  setConfiguration: (configuration: T) => void,
  setInitialConfiguration?: (configuration: T) => void,
) {
  /**
   * On initial render we apply filters from query string (URL) if they are set.
   * Later if user changes configuration manually we need to remove all filters.
   * This is a flag whether to keep filters or remove them on configuration change.
   */
  const needToRemoveFilters = useRef<boolean>(false);

  useEffect(
    function onConfigurationChange() {
      if (configuration) {
        if (needToRemoveFilters.current) {
          setConfiguration(configuration);
        } else {
          // after initial render we need to set this flag to 'true' to clear filters when user changes configuration
          // (changes the current one in the editor or picks another one)
          if (setInitialConfiguration) {
            setInitialConfiguration(configuration);
          }
          needToRemoveFilters.current = true;
        }
      }
    },
    [configuration],
  );

  return needToRemoveFilters;
}
